export default function getActiveGroupDataType (groupData, selectedGroupUA) {
  let output = ''
  const groupTypes = ['districts', 'schools', 'educators', 'classes']
  groupTypes.forEach((groupType) => {
    if (groupData[groupType] && groupData[groupType][selectedGroupUA]) {
      output = groupType
    }
  })
  return output
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getActiveGroupDataType.js